// import { createSelector } from 'reselect';
import { namespace, OnboardingSlice } from '../models';

export const selectStore = (state: OnboardingSlice) => state[namespace];
